import React from "react";
import { Link } from "react-router-dom";
import tutifyLogo from "../../assets/images/tutify-logo-light.png";

const FooterLogo = () => {
  return (
    <Link className="navbar-brand" to="/">
      <img src={tutifyLogo} alt="Tutify Logo" />
    </Link>
  );
};

export default FooterLogo;
